export default __webpack_public_path__ + "static/media/slide1.ee44ca5c.jpg";